// frontend/src/utils/text.ts
export function trimGraphemes(input: string, max: number): string {
  if (!input) return '';
  try {
    // Prefer Intl.Segmenter for true grapheme segmentation
    // Falls back to code point splitting if not available
    const seg = (Intl as any)?.Segmenter
      ? new (Intl as any).Segmenter('en', { granularity: 'grapheme' })
      : null;
    if (seg) {
      const it = seg.segment(input);
      const result: string[] = [];
      let count = 0;
      for (const s of it) {
        if (count >= max) break;
        result.push(s.segment);
        count++;
      }
      return result.join('');
    }
    const points = Array.from(input);
    return points.slice(0, max).join('');
  } catch {
    return (input || '').slice(0, max);
  }
}

export function graphemeLength(input: string): number {
  try {
    const seg = (Intl as any)?.Segmenter
      ? new (Intl as any).Segmenter('en', { granularity: 'grapheme' })
      : null;
    if (seg) {
      let n = 0;
      for (const _ of seg.segment(input || '')) n++;
      return n;
    }
    return Array.from(input || '').length;
  } catch {
    return (input || '').length;
  }
}
